import Payments from 'components/activity/payments/main/containers/PaymentsContainer';
import StandingOrder from 'components/activity/payments/standingOrder/main/containers/MainContainer';
import MakePayment from 'components/activity/payments/makePayment/containers/MakePaymentContainer';
import ManagePayees from 'components/activity/payments/managePayee/containers/ManagePayeesContainer';
import CreatePayee from 'components/activity/payments/createPayee/containers/CreatePayeeContainer';
import ForceCreatePayee from 'components/activity/payments/createPayee/containers/ForceCreatePayeeContainer';
import ConfirmationOfPayee from 'components/activity/payments/createPayee/containers/ConfirmationOfPayeeContainer';
import MakePaymentForm from 'components/activity/payments/uk/form/containers/MakePaymentFormContainer';
import UKPaymentSuccess from 'components/activity/payments/uk/success/containers/PaymentSuccessContainer';
import StandingOrderPayee from 'components/activity/payments/standingOrder/payee/containers/StandingOrderPayeeContainer';
import StandingOrderForm from 'components/activity/payments/standingOrder/form/containers/StandingOrderFormContainer';
import StandingOrderPaymentSuccess from 'components/activity/payments/standingOrder/success/containers/PaymentSuccessContainer';
import DirectDebitContainer from 'components/activity/payments/directDebit/containers/DirectDebitContainer';
import DirectDebitItemContainer from 'components/activity/payments/directDebit/containers/DirectDebitItemContainer';
import AddCash from 'components/activity/payments/addCash/presentational/AddCash';

const paymentsRoutes = [
    { path: '', element: <Payments />, pageTitle: 'Payments' },
    {
        path: 'standing-order/payee',
        element: <StandingOrderPayee />,
        pageTitle: 'Payee | Standing Order',
    },
    {
        path: 'standing-order/form',
        element: <StandingOrderForm />,
        pageTitle: 'Form | Standing Order',
    },
    {
        path: 'standing-order/success',
        element: <StandingOrderPaymentSuccess />,
        pageTitle: 'Status | Standing Order',
    },
    {
        path: 'standing-order',
        element: <StandingOrder />,
        pageTitle: 'Standing Order',
    },
    {
        path: 'standing-order/:id',
        element: <StandingOrder />,
        pageTitle: 'Standing Order',
    },
    {
        path: 'direct-debit',
        element: <DirectDebitContainer />,
        pageTitle: 'Direct Debits',
    },
    {
        path: 'direct-debit/:id',
        element: <DirectDebitItemContainer />,
        pageTitle: 'Direct Debits',
    },
    {
        path: 'make-payment/form',
        element: <MakePaymentForm />,
        pageTitle: 'Form | Make Payment',
    },
    {
        path: 'make-payment/success',
        element: <UKPaymentSuccess />,
        pageTitle: 'Status | Make Payment',
    },
    { path: 'make-payment', element: <MakePayment />, pageTitle: 'Make Payment' },
    {
        path: 'manage-payees',
        element: <ManagePayees />,
        pageTitle: 'Manage Payees',
    },
    { path: 'add-payee', element: <CreatePayee />, pageTitle: 'Add Payee' },
    {
        path: 'force-add-payee',
        element: <ForceCreatePayee />,
        pageTitle: 'Add Payee',
    },
    {
        path: 'confirmation-payee',
        element: <ConfirmationOfPayee />,
        pageTitle: 'Add Payee',
    },
    { path: 'add-cash', element: <AddCash />, pageTitle: 'Add Cash' },
];

export default paymentsRoutes;
